import {h, Fragment} from "preact"
import { useEffect, useState } from 'preact/hooks';
import FacetCheckboxItem from './FacetCheckboxItem';
import FacetColorItem from './FacetColorItem';
import FacetTileItem from './FacetTileItem';

export default function FacetItem({facet, toggleProductFilter}) {
    const [isShowMoreActive, setShowMoreActive] = useState(false);
    const [facetNew, setSetFacetNew] = useState(facet);
    const maxElements = facet.field === 'customFields.filter-color' || facet.field === 'skus.customFields.size' ? 12 : 10;
    const shouldShowButton = facet.data?.length > maxElements;

    const handleShowMore = () => {
        setShowMoreActive(prev => !prev);
    }

    useEffect(() => {
        if (!isShowMoreActive) {
            setSetFacetNew({
                ...facet,
                data: facet.data.slice(0, maxElements),
            });
        } else {
            setSetFacetNew(facet);
        }
    }, [isShowMoreActive, facet]);

    return (
        <div>
            {facet.field === 'customFields.filter-color' ? (
                <FacetColorItem facet={facetNew} toggleProductFilter={toggleProductFilter} />
            ) : facet.field === 'skus.customFields.size' ? (
                <FacetTileItem facet={facetNew} toggleProductFilter={toggleProductFilter} />
            ) : (
                <FacetCheckboxItem facet={facetNew} toggleProductFilter={toggleProductFilter} />
            )}
            {shouldShowButton ? (
                <button class="button-show-more link underlined-link" type="button" onClick={handleShowMore}>
                    <span class="label-show-more label-text"><span aria-hidden="true">
                        {isShowMoreActive ? '-' : '+'}
                    </span>{isShowMoreActive ? 'Show Less' : 'Show More'}</span>
                </button>
            ) : null}
        </div>
    )
}
